import { TradingViewWidget } from '@components/TradingViewWidget'
import { useService } from 'solid-services'
import { useSingle } from '../state'

export default function LiveChart() {
  const { setupQuery } = useService(useSingle)()

  return (
    <TradingViewWidget
      id='tv-widget-single'
      exchange={setupQuery.data?.exchange}
      symbol={setupQuery.data?.symbol}
    />
  )
}
